import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=2337d908&scoped=true&"
import script from "./PromotionPage.vue?vue&type=script&lang=js&"
export * from "./PromotionPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPage.vue?vue&type=style&index=0&id=2337d908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337d908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2337d908')) {
      api.createRecord('2337d908', component.options)
    } else {
      api.reload('2337d908', component.options)
    }
    module.hot.accept("./PromotionPage.vue?vue&type=template&id=2337d908&scoped=true&", function () {
      api.rerender('2337d908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PromotionPage.vue"
export default component.exports